import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { colors, breakpoints, spacing } = useTheme();

  return {
    link: css`
      color: ${colors.white};
      font-weight: 400;
      text-align: center;
      padding-top: ${spacing.s};

      ${breakpoints.m} {
        font-size: 1.25rem;
        line-height: 1.875rem;
      }

      button {
        display: inline-block;
        padding: 0 3px;
      }
    `,
    linkWrapper: css`
      width: 100%;
      margin: 0 auto;
      text-align: center;
    `,
    externalLink: css`
      color: ${colors.white};
      font-weight: 400;
      font-size: 1rem;
      padding-top: ${spacing.xs};
      display: inline-block;
      border: 1px solid transparent;

      &:focus {
        outline: 0;
        border: 1px solid ${colors.white};
      }

      ${breakpoints.m} {
        font-size: 1.25rem;
      }
    `,
    OnboardingWrapper: css`
      margin: 1rem 0 ${spacing.s};
    `,
    daysLink: css`
      text-transform: lowercase;
    `,
    footballLink: css`
      text-transform: capitalize;
    `,
  };
};
